// Значки разделов — общая карта для полосы разделов и палитры.
//
// Лежат не в `sections.ts` намеренно: тот реестр держится данными без React, чтобы его можно
// было читать откуда угодно, включая проверки. Здесь же значения — компоненты.
//
// Карта одна, потому что раздел обязан выглядеть одинаково везде, где назван. Пока копий было
// две, «Найм» в палитре и «Найм» в полосе разошлись бы при первой же смене значка, и это тот
// самый вид расхождения, который никто не замечает годами.

import type { RemixiconComponentType } from '@remixicon/react';
import {
  RiBuilding4Line,
  RiCalculatorLine,
  RiSettings3Line,
  RiTaskLine,
  RiTeamLine,
  RiUserAddLine,
  RiWallet3Line,
} from '@remixicon/react';

import type { SectionSlug } from '@/app/sections';

export const ЗНАЧКИ_РАЗДЕЛОВ: Record<SectionSlug, RemixiconComponentType> = {
  money: RiWallet3Line,
  people: RiTeamLine,
  sites: RiBuilding4Line,
  payroll: RiCalculatorLine,
  cases: RiTaskLine,
  hiring: RiUserAddLine,
  settings: RiSettings3Line,
};
